import React, { useEffect, useState } from "react";
import { EmployerinformationI, EmployerSelectValue } from "../interfaces";
import { getAllEmployer } from "../redux/selfService/selfServiceSlice";
import Select from "react-select";
import { useAppDispatch, useAppSelector } from "../redux/hooks";

interface PropsI {
  onChange: (e: EmployerSelectValue) => void;
  defaultValue?: EmployerSelectValue | null;
}

const EmployerSelect = ({ onChange, defaultValue }: PropsI) => {
  const dispatch = useAppDispatch();
  const { isLoading, allEmployer } = useAppSelector((state) => state?.selfService);
  const [inputString, setInputString] = useState("");
  const [employerNameSelect, setEmployerNameSelect] = useState<any[]>([]);
  const [selectedValue, setSelectedValue] = useState<EmployerSelectValue | null>(
    defaultValue || null
  );

 // console.log("Received defaultValue:", defaultValue);

  // Update selectedValue whenever defaultValue changes
  useEffect(() => {
    setSelectedValue(defaultValue || null);
    // onChange(defaultValue);
  }, [defaultValue]);

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      if (inputString && inputString.length > 1) {
        dispatch(getAllEmployer(inputString));
      }
    }, 1000);

    return () => clearTimeout(timeOutId);
  }, [inputString, dispatch]);

  useEffect(() => {
    if (allEmployer && allEmployer.length > 0) {
      const empArr: any[] = [];
      allEmployer.forEach((emp: EmployerinformationI) => {
        empArr.push({
          value: emp,
          label: emp.txtemployername,
        });
      });
      setEmployerNameSelect(empArr);
    }
  }, [allEmployer]);

  // Handle changes in the selected employer
  const handleSelectChange = (selectedOption: EmployerSelectValue | null) => {
    setSelectedValue(selectedOption);
    onChange(selectedOption); // Notify the parent component about the change
  };

  return (
    <Select
      id="employer"
      className="react-select-container"
      classNamePrefix="react-select"
      isLoading={isLoading}
      options={employerNameSelect}
      placeholder="Type employer name to search"
      value={selectedValue} // Set the selected value here
      onChange={handleSelectChange} // Use the handleSelectChange function
      onInputChange={(val) => setInputString(val)}
    />
  );
};

export default EmployerSelect;
